import React from 'react';
import './TitleSectionComponent.css';

const TitleSectionComponent = ({ children, className }) => {
  return (
    <div className={`titulo-componente ${className}`}>
      <h2>{children}</h2>
    </div>
  );
};

export default TitleSectionComponent;
